import React from "react";
import type { ColumnsType } from "antd/es/table";
import type { SortOrder } from "antd/es/table/interface";

import style from "~/pages/DNM/DNM.less";

export interface resultDataIProps {
  id?: string | number;
  key?: string | number;
  fio: string;
  email: string;
  dealer: string;
  position: string;
  status: string;
  fioCsvEntry: string;
  emailCsvEntry: string;
  dealerCsvEntry: string;
  positionCsvEntry: string;
  count: string;
  percentage: string | number;
  differentFields: string[];
  matchedFields: string[];
  partialMatchFields: string[];
}

const matchHighlightClass = (
  record: resultDataIProps,
  field: string,
): string | undefined => {
  if (record.differentFields?.includes(field)) {
    return style.red;
  }
  if (record.partialMatchFields?.includes(field)) {
    return style.orange;
  }
  return undefined;
};

export const getColumnsDnm = (
  t: (val: string) => string,
  sortOrder?: SortOrder,
): ColumnsType<resultDataIProps> => {
  return [
    {
      title: t("dnm.base"),
      children: [
        {
          title: t("dnm.fio"),
          dataIndex: "fio",
          key: "fio",
        },
        {
          title: t("dnm.workEmail"),
          dataIndex: "email",
          key: "email",
        },
        {
          title: t("dnm.dc"),
          dataIndex: "dealer",
          key: "dealer",
        },
        {
          title: t("dnm.position"),
          dataIndex: "position",
          key: "position",
        },
        {
          title: t("dnm.status"),
          dataIndex: "status",
          key: "status",
          className: style["dnm-section-border"],
          render: (value: string) => (value ? t(`employee.${value}`) : ""),
        },
      ],
    },
    {
      title: t("dnm.comparisonData"),
      children: [
        {
          title: t("dnm.fio"),
          dataIndex: "fioCsvEntry",
          key: "fioCsvEntry",
          onCell: (record) => ({
            className: matchHighlightClass(record, "name"),
          }),
        },
        {
          title: t("dnm.workEmail"),
          dataIndex: "emailCsvEntry",
          key: "emailCsvEntry",
          onCell: (record) => ({
            className: matchHighlightClass(record, "email"),
          }),
        },
        {
          title: t("dnm.dc"),
          dataIndex: "dealerCsvEntry",
          key: "dealerCsvEntry",
        },
        {
          title: t("dnm.position"),
          dataIndex: "positionCsvEntry",
          key: "positionCsvEntry",
          onCell: (record) => ({
            className: matchHighlightClass(record, "position"),
          }),
        },
        {
          title: t("dnm.worksheetsOrdersCount"),
          dataIndex: "count",
          key: "count",
          className: style["dnm-section-border"],
        },
      ],
    },
    {
      title: "",
      children: [
        {
          title: t("dnm.coincidence"),
          dataIndex: "percentage",
          key: "percentage",
          sorter: true,
          sortOrder,
          render: (value: string | number) => <span>{value}%</span>,
        },
      ],
    },
  ];
};
